import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ReportListPage" */
	'pages/intervention/Report/ReportListPage'));

export default [{ component, exact: true, path: '/sub_partitions/:subPartitionId/reports' }];